import { Component, computed, effect, inject } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { MatTooltipModule } from "@angular/material/tooltip";
import { RouterLink, RouterLinkActive } from "@angular/router";
import { DEFAULT_ORGANIZATION_LOGO } from "../../shared/constants";
import { BreadcrumbService } from "../breadcrumb.service";
import { NavItem, ShellNavService } from "../shell-nav.service";

@Component({
	selector: "mch-shell-rail",
	standalone: true,
	imports: [
		MatButtonModule,
		MatIconModule,
		MatMenuModule,
		MatTooltipModule,
		RouterLink,
		RouterLinkActive,
	],
	templateUrl: "./shell-rail.component.html",
	styleUrl: "./shell-rail.component.scss",
	host: {
		"[class.collapsed]": "nav.railCollapsed()",
	},
})
export class ShellRailComponent {
	protected readonly nav = inject(ShellNavService);
	private readonly breadcrumbs = inject(BreadcrumbService);
	protected readonly defaultLogo = DEFAULT_ORGANIZATION_LOGO;

	protected readonly items = computed<NavItem[]>(() =>
		this.nav.mode() === "organization" ? this.nav.organizationItems() : this.nav.globalItems(),
	);

	protected readonly currentOrganization = computed(() => {
		const id = this.nav.organizationId();
		if (!id) {
			return null;
		}
		return this.nav.switchableOrganizations().find((o) => o.id === id) ?? null;
	});

	constructor() {
		// The breadcrumb for an org route is the sentinel ":id". Once the name is
		// known, register it so the crumb reads "Acme Corp" rather than the raw id.
		// This lives in an effect rather than the computed above because setLabel
		// writes a signal, which Angular forbids inside a computed.
		effect(() => {
			const organization = this.currentOrganization();
			if (organization?.id && organization.name) {
				this.breadcrumbs.setLabel(organization.id, organization.name);
			}
		});
	}

	protected onLogoError(event: Event): void {
		(event.target as HTMLImageElement).src = this.defaultLogo;
	}
}
